var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 324 454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.217%",
    y1: "43.452%",
    x2: "46.452%",
    y2: "55.458%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5454",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 0h28.744v28.7H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F2F2F5",
    width: 324,
    height: 454,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.634 434.073h-18.53v-54.137a5.638 5.638 0 015.644-5.636h7.204a5.638 5.638 0 015.645 5.636v54.137h.037z",
    fill: "#E4E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.64 324.872v93.627a8.496 8.496 0 01-8.505 8.491h-33.57c-4.68 0-8.504-3.782-8.504-8.491v-93.627h50.578z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.467 409.822h-4.196a2.724 2.724 0 01-2.711-2.707v-39.267a2.724 2.724 0 012.71-2.707h4.197a2.724 2.724 0 012.71 2.707v39.267a2.724 2.724 0 01-2.71 2.707z",
    fill: "#C9CBD3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#262E4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.146 370.11v8.825l-2.674-4.413zM115.284 377.303c-.297.148-.854.297-1.56.297-1.67 0-2.934-1.038-2.934-3.004 0-1.854 1.263-3.114 3.083-3.114.742 0 1.188.148 1.41.26l-.185.63a2.685 2.685 0 00-1.188-.26c-1.374 0-2.303.89-2.303 2.447 0 1.446.817 2.373 2.266 2.373a3.18 3.18 0 001.262-.26l.149.631zM119.146 381.234v8.862l-2.674-4.413zM112.276 383.347h-1.783v-.63h4.382v.63h-1.82v5.266h-.78z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FC5454",
    d: "M126.35 373.855v1.112h-4.79v-1.112zM126.35 385.127v1.112h-4.79v-1.112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.292 323.945H92.446V435h67.846V323.945zm-1.857 1.854v107.347H94.302V325.799h64.133z",
    fill: "#FFAE33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.26 434.036H45.767v-54.137a5.638 5.638 0 015.644-5.636h7.204a5.638 5.638 0 015.645 5.636v54.137z",
    fill: "#E4E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.302 324.835v93.627a8.496 8.496 0 01-8.504 8.491h-33.57c-4.679 0-8.504-3.782-8.504-8.491v-93.59l50.578-.037z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.093 409.785h-4.196a2.724 2.724 0 01-2.711-2.707v-39.267a2.724 2.724 0 012.71-2.707h4.197a2.724 2.724 0 012.71 2.707v39.267a2.7 2.7 0 01-2.71 2.707z",
    fill: "#C9CBD3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#262E4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.772 370.073v8.862l-2.674-4.45zM43.947 377.266c-.297.148-.854.297-1.56.297-1.67 0-2.933-1.039-2.933-3.004 0-1.854 1.262-3.115 3.082-3.115.743 0 1.188.149 1.41.26l-.185.63a2.685 2.685 0 00-1.188-.26c-1.374 0-2.302.89-2.302 2.448 0 1.446.817 2.373 2.265 2.373a3.18 3.18 0 001.262-.26l.149.631zM47.772 381.234v8.825l-2.674-4.413zM40.939 383.347h-1.783v-.63h4.382v.63h-1.82v5.266h-.779z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.918 323.908H21.072v111.055h67.846V323.908zm-1.857 1.854v107.347H22.928V325.762h64.133z",
    fill: "#FFAE33"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M206.97 434.073h-18.53v-54.137a5.638 5.638 0 015.645-5.636h7.204a5.638 5.638 0 015.645 5.636v54.137h.037z",
    fill: "#E4E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.013 324.872v93.627a8.496 8.496 0 01-8.504 8.491h-33.57c-4.68 0-8.504-3.782-8.504-8.491v-93.627h50.578z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.804 409.822h-4.197a2.724 2.724 0 01-2.71-2.707v-39.267a2.724 2.724 0 012.71-2.707h4.197a2.724 2.724 0 012.71 2.707v39.267a2.724 2.724 0 01-2.71 2.707z",
    fill: "#C9CBD3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#262E4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.483 370.11v8.825l-2.674-4.413zM186.658 377.303c-.297.148-.854.297-1.56.297-1.67 0-2.934-1.038-2.934-3.004 0-1.854 1.263-3.114 3.083-3.114.742 0 1.188.148 1.41.26l-.185.63a2.685 2.685 0 00-1.188-.26c-1.374 0-2.303.89-2.303 2.447 0 1.446.817 2.373 2.266 2.373a3.18 3.18 0 001.262-.26l.149.631zM190.483 381.234v8.862l-2.674-4.413zM183.65 383.347h-1.783v-.63h4.382v.63h-1.82v5.266h-.78z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FC5454",
    d: "M202.515 373.855v1.112h-9.618v-1.112zM197.724 385.127v1.112h-4.827v-1.112z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.629 323.945h-67.847V435h67.847V323.945zm-1.857 1.854v107.347h-64.133V325.799h64.133z",
    fill: "#FFAE33"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M278.308 434.073h-18.53v-54.137a5.638 5.638 0 015.644-5.636h7.204a5.638 5.638 0 015.645 5.636v54.137h.037z",
    fill: "#E4E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.35 324.872v93.627a8.496 8.496 0 01-8.504 8.491h-33.57c-4.68 0-8.504-3.782-8.504-8.491v-93.627h50.578z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.14 409.822h-4.196a2.724 2.724 0 01-2.71-2.707v-39.267a2.724 2.724 0 012.71-2.707h4.197a2.724 2.724 0 012.71 2.707v39.267a2.7 2.7 0 01-2.71 2.707z",
    fill: "#C9CBD3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#262E4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.82 370.11v8.825l-2.674-4.413zM257.995 377.303c-.297.148-.854.297-1.56.297-1.671 0-2.934-1.038-2.934-3.004 0-1.854 1.263-3.114 3.083-3.114.742 0 1.188.148 1.41.26l-.185.63a2.685 2.685 0 00-1.188-.26c-1.374 0-2.303.89-2.303 2.447 0 1.446.817 2.373 2.266 2.373a3.18 3.18 0 001.262-.26l.149.631zM261.82 381.234v8.862l-2.674-4.413zM254.987 383.347h-1.783v-.63h4.382v.63h-1.82v5.266h-.78z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.369 84.95h-4.197a2.724 2.724 0 01-2.71-2.707V42.976a2.724 2.724 0 012.71-2.707l6.908 41.974a2.7 2.7 0 01-2.711 2.707z",
    fill: "url(#a)",
    opacity: 0.7,
    transform: "translate(243.772 324.872)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M302.966 323.945h-67.847V435h67.847V323.945zm-1.858 1.854v107.347h-64.132V325.799h64.132z",
    fill: "#FFAE33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.394 316.735v-9.898H22v9.898h2.394zm4.446 0v-6.076l4.004 6.076h2.394v-9.898h-2.394v6.132l-4.004-6.132h-2.394v9.898h2.394zm14.26 0l3.444-9.898h-2.562l-2.422 7.448-2.422-7.448h-2.562l3.43 9.898H43.1zm6.574 0l.616-1.806H54l.616 1.806h2.548l-3.626-9.828H50.78l-3.626 9.828h2.52zm3.71-3.626h-2.478l1.246-3.64 1.232 3.64zm10.69 3.626V314.9h-3.192v-8.064h-2.394v9.898h5.586zm3.9 0v-9.898H65.58v9.898h2.394zm5.79 0c1.055 0 1.972-.21 2.751-.63a4.364 4.364 0 001.792-1.757c.415-.751.623-1.612.623-2.583 0-.97-.208-1.83-.623-2.576a4.298 4.298 0 00-1.785-1.736c-.775-.41-1.694-.616-2.758-.616h-3.738v9.898h3.738zm-.21-2.142H72.42v-5.656h1.134c.933 0 1.659.247 2.177.742s.777 1.19.777 2.086c0 .896-.259 1.591-.777 2.086-.518.495-1.244.742-2.177.742z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.183 147.168h-18.46V93.049a5.632 5.632 0 015.635-5.634h7.19a5.632 5.632 0 015.635 5.634v54.119z",
    fill: "#E4E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.196 38.004v93.595c0 4.67-3.78 8.489-8.488 8.489h-33.51c-4.67 0-8.488-3.781-8.488-8.489V38.041l50.486-.037z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.029 122.925H52.84a2.721 2.721 0 01-2.706-2.705V80.965a2.721 2.721 0 012.706-2.706h4.189a2.721 2.721 0 012.706 2.706v39.255a2.697 2.697 0 01-2.706 2.705z",
    fill: "#C9CBD3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC5454",
    d: "M59.698 86.933v1.112h-9.6v-1.112z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#262E4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.725 83.226v8.86l-2.669-4.449zM43.907 90.417c-.296.149-.853.297-1.557.297-1.668 0-2.928-1.038-2.928-3.003 0-1.853 1.26-3.113 3.076-3.113.742 0 1.187.148 1.41.26l-.186.63a2.677 2.677 0 00-1.186-.26c-1.372 0-2.299.89-2.299 2.446 0 1.446.816 2.373 2.261 2.373a3.17 3.17 0 001.26-.26l.15.63zM47.725 94.384v8.822l-2.669-4.411zM40.905 96.496h-1.78v-.63H43.5v.63h-1.816v5.264h-.778z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.394 30v-6.076L28.398 30h2.394v-9.898h-2.394v6.132l-4.004-6.132H22V30h2.394zm14.61 0v-1.918h-3.766v-2.198h3.346v-1.806h-3.346v-2.072h3.766v-1.904h-6.16V30h6.16zm6.42.084c.821 0 1.552-.154 2.191-.462a4.613 4.613 0 001.575-1.204c.41-.495.71-1.031.896-1.61v-2.366H45.06v1.722h3.024c-.177.579-.48 1.024-.91 1.337-.43.313-.929.469-1.498.469-.887 0-1.57-.252-2.051-.756-.48-.504-.721-1.227-.721-2.17 0-.868.229-1.556.686-2.065.457-.509 1.064-.763 1.82-.763.485 0 .9.105 1.246.315.345.21.602.492.77.847h2.534c-.196-1.036-.695-1.857-1.498-2.464s-1.825-.91-3.066-.91c-.99 0-1.855.212-2.597.637a4.376 4.376 0 00-1.722 1.785c-.406.765-.609 1.638-.609 2.618s.203 1.853.609 2.618c.406.765.982 1.36 1.729 1.785.747.425 1.62.637 2.618.637zM53.636 30l.616-1.806h3.71L58.578 30h2.548L57.5 20.172h-2.758L51.116 30h2.52zm3.71-3.626h-2.478l1.246-3.64 1.232 3.64zM66.874 30v-7.994h2.688v-1.904h-7.756v1.904h2.66V30h2.408zm6.49 0v-9.898H70.97V30h2.394zm7.862 0l3.444-9.898h-2.562l-2.422 7.448-2.422-7.448h-2.562L78.132 30h3.094zm10.928 0v-1.918h-3.766v-2.198h3.346v-1.806h-3.346v-2.072h3.766v-1.904h-6.16V30h6.16z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.786 290.535h-18.531v-54.137a5.638 5.638 0 015.644-5.636h7.205a5.638 5.638 0 015.645 5.636v54.137h.037z",
    fill: "#E4E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.791 181.297v92.218c0 5.45-4.419 9.9-9.915 9.9h-30.749c-5.459 0-9.915-4.412-9.915-9.9v-92.218h50.58z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.581 266.247h-4.196a2.724 2.724 0 01-2.711-2.707v-39.267a2.724 2.724 0 012.71-2.707h4.197a2.724 2.724 0 012.711 2.707v39.267c.037 1.52-1.188 2.707-2.71 2.707z",
    fill: "#C9CBD3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#262E4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.26 226.535v8.862l-2.674-4.413zM115.435 233.728c-.297.148-.854.297-1.56.297-1.67 0-2.934-1.039-2.934-3.004 0-1.854 1.263-3.115 3.083-3.115.743 0 1.188.149 1.411.26l-.186.63a2.685 2.685 0 00-1.188-.26c-1.374 0-2.303.89-2.303 2.448 0 1.446.817 2.373 2.266 2.373a3.18 3.18 0 001.262-.26l.149.631zM119.26 237.696v8.862l-2.674-4.45zM112.427 239.81h-1.783v-.631h4.382v.63h-1.82v5.266h-.78z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FC5454",
    opacity: 0.25,
    d: "M131.33 230.28v1.112h-9.619v-1.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC5454",
    d: "M131.33 241.552v1.112h-9.619v-1.112z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.444 180.37H92.596v111.055h67.848V180.37zm-1.857 1.854V289.57H94.453V182.224h64.134z",
    fill: "#FFAE33",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.224 290.535H45.693v-54.137a5.638 5.638 0 015.645-5.636h7.204a5.638 5.638 0 015.645 5.636v54.137h.037z",
    fill: "#E4E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.267 181.297V267.1c0 11.866-4.42 16.278-9.916 16.278H39.603c-5.46 0-9.916-4.412-9.916-9.9v-92.181h50.58z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.057 266.247H52.86a2.724 2.724 0 01-2.71-2.707v-39.267a2.724 2.724 0 012.71-2.707h4.197a2.724 2.724 0 012.71 2.707v39.267a2.677 2.677 0 01-2.71 2.707z",
    fill: "#C9CBD3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#262E4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.735 226.535v8.862l-2.673-4.413zM43.91 233.728c-.297.148-.854.297-1.56.297-1.67 0-2.933-1.039-2.933-3.004 0-1.854 1.263-3.115 3.082-3.115.743 0 1.189.149 1.411.26l-.185.63a2.685 2.685 0 00-1.189-.26c-1.374 0-2.302.89-2.302 2.448 0 1.446.817 2.373 2.265 2.373a3.18 3.18 0 001.263-.26l.148.631zM47.735 237.696v8.862l-2.673-4.45zM40.902 239.81H39.12v-.631h4.382v.63h-1.82v5.266h-.78z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FC5454",
    d: "M59.768 241.552v1.112h-9.582v-1.112z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.92 180.37H21.072v111.055H88.92V180.37zm-1.857 1.854V289.57H22.928V182.224h64.135z",
    fill: "#FFAE33",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.125 290.535h-18.531v-54.137a5.638 5.638 0 015.644-5.636h7.205a5.638 5.638 0 015.644 5.636v54.137h.038z",
    fill: "#E4E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.13 181.297v92.218c0 5.45-4.419 9.9-9.915 9.9h-30.749c-5.459 0-9.915-4.412-9.915-9.9v-92.218h50.58z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.957 266.247h-4.196a2.724 2.724 0 01-2.711-2.707v-39.267a2.724 2.724 0 012.71-2.707h4.197a2.724 2.724 0 012.711 2.707v39.267a2.7 2.7 0 01-2.71 2.707z",
    fill: "#C9CBD3"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#262E4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.636 226.535v8.862l-2.674-4.413zM186.774 233.728c-.297.148-.854.297-1.56.297-1.671 0-2.934-1.039-2.934-3.004 0-1.854 1.263-3.115 3.083-3.115.742 0 1.188.149 1.41.26l-.185.63a2.685 2.685 0 00-1.188-.26c-1.374 0-2.303.89-2.303 2.448 0 1.446.817 2.373 2.266 2.373a3.18 3.18 0 001.262-.26l.149.631zM190.636 237.696v8.862l-2.674-4.45zM183.766 239.81h-1.783v-.631h4.382v.63h-1.82v5.266h-.78z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FC5454",
    d: "M202.668 230.28v1.112h-9.618v-1.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC5454",
    opacity: 0.25,
    d: "M202.668 241.552v1.112h-9.618v-1.112z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.783 180.37h-67.848v111.055h67.848V180.37zm-1.857 1.854V289.57H165.79V182.224h64.135z",
    fill: "#FFAE33",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFAE33",
    fill: "#FFB543",
    fillRule: "nonzero",
    d: "M224.282 194.164l-21.614 48.13 50.32-19.467H223.91z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224.282 194.164)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262E4D",
    fillRule: "nonzero",
    d: "M-37.545-90.55H73.01v181.1H-37.545z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.866 89.14H2.6V-2.855a5.638 5.638 0 015.644-5.636h18.94a5.638 5.638 0 015.645 5.636V89.14h.037z",
    fill: "#E4E5E9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.886-89.177H48.35c5.83 0 10.547 4.635 10.696 10.456l2.822 131.375c0 13.756-11.475 24.917-25.661 24.917H-.706c-14.186 0-25.66-11.16-25.66-24.917l2.784-131.412c.149-5.784 4.902-10.42 10.696-10.42z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.876 49.539h-10.25a2.724 2.724 0 01-2.71-2.707v-67.56a2.724 2.724 0 012.71-2.707h10.25a2.724 2.724 0 012.71 2.707v67.56a2.724 2.724 0 01-2.71 2.707z",
    fill: "#C9CBD3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#262E4D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.905-15.314V-.853L1.56-8.083zM-.334-3.56c-.446.223-1.374.445-2.563.445-2.71 0-4.753-1.705-4.753-4.894 0-3.004 2.042-5.08 5.05-5.08 1.189 0 1.969.26 2.303.445l-.297 1a4.666 4.666 0 00-1.931-.407c-2.266 0-3.751 1.446-3.751 3.968 0 2.373 1.374 3.893 3.714 3.893.742 0 1.522-.148 2.042-.408l.186 1.038zM5.905 2.892v14.424L1.56 10.123zM-5.273 6.34h-2.934V5.266h7.13v1.076h-2.934v8.565h-1.262V6.341z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FC5454",
    strokeWidth: 3,
    d: "M9.878-8.268h15.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC5454",
    fillRule: "nonzero",
    opacity: 0.25,
    d: "M25.587 9.567v1.112H9.878V9.567z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#262E4D",
    strokeWidth: 5,
    d: "M-37.545 90.55v-181.1H73.01"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M253.953 193.237h-30.6v30.554h30.6v-30.554zm-1.857 1.854v26.846H225.21V195.09h26.886z",
    fill: "#262E4D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.394 173.349v-3.472h1.484c.775 0 1.433-.138 1.974-.413.541-.275.95-.653 1.225-1.134.275-.48.413-1.03.413-1.645 0-.99-.308-1.776-.924-2.36-.616-.582-1.512-.874-2.688-.874H22v9.898h2.394zm1.218-5.39h-1.218v-2.576h1.218c.961 0 1.442.434 1.442 1.302 0 .85-.48 1.274-1.442 1.274zm10.158 5.488c.924 0 1.766-.217 2.527-.651a4.779 4.779 0 001.806-1.813c.443-.775.665-1.647.665-2.618 0-.97-.22-1.841-.658-2.611a4.743 4.743 0 00-1.799-1.806c-.76-.434-1.608-.651-2.541-.651-.924 0-1.766.217-2.527.65a4.793 4.793 0 00-1.806 1.807c-.443.77-.665 1.64-.665 2.61 0 .972.222 1.844.665 2.619a4.779 4.779 0 001.806 1.813c.76.434 1.603.65 2.527.65zm0-2.24c-.784 0-1.407-.257-1.869-.77-.462-.513-.693-1.204-.693-2.072 0-.877.231-1.57.693-2.08.462-.508 1.085-.762 1.869-.762s1.407.257 1.869.77c.462.513.693 1.204.693 2.072 0 .868-.233 1.559-.7 2.072-.467.513-1.087.77-1.862.77zm10.396 2.24c.737 0 1.365-.13 1.883-.392.518-.261.91-.611 1.176-1.05.266-.439.399-.92.399-1.442 0-.644-.145-1.167-.434-1.568a2.973 2.973 0 00-1.036-.917 11.08 11.08 0 00-1.554-.637c-.439-.159-.775-.29-1.008-.392a1.76 1.76 0 01-.581-.4.836.836 0 01-.231-.594c0-.29.086-.509.259-.658.173-.15.399-.224.679-.224.327 0 .586.096.777.287.191.191.31.45.357.777h2.59c-.084-.915-.45-1.633-1.099-2.156-.649-.523-1.524-.784-2.625-.784-.681 0-1.286.114-1.813.343-.527.229-.94.558-1.239.987-.299.43-.448.938-.448 1.526 0 .635.142 1.15.427 1.547.285.397.625.695 1.022.896.397.2.908.408 1.533.623.43.15.765.278 1.008.385.243.107.446.245.609.413a.868.868 0 01.245.63c0 .28-.089.504-.266.672-.177.168-.42.252-.728.252-.355 0-.646-.107-.875-.322-.229-.215-.362-.509-.399-.882h-2.548c.065.97.457 1.727 1.176 2.268.719.541 1.633.812 2.744.812zm7.582-.098v-9.898h-2.394v9.898h2.394zm6.476 0v-7.994h2.688v-1.904h-7.756v1.904h2.66v7.994h2.408zm6.49 0v-9.898H64.32v9.898h2.394zm7.862 0l3.444-9.898h-2.562l-2.422 7.448-2.422-7.448h-2.562l3.43 9.898h3.094zm10.928 0v-1.918h-3.766v-2.198h3.346v-1.806h-3.346v-2.072h3.766v-1.904h-6.16v9.898h6.16z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResults);
export default __webpack_public_path__ + "static/media/results.cfd3ecdc.svg";
export { ForwardRef as ReactComponent };